import React from 'react';
import styled from 'styled-components';

import {
  TagButton,
  ButtonText,
  ButtonIcon,
} from '@prisjakt/ui/button/variants';
import { IconClose } from '@prisjakt/ui/icon/close';
import { Behavior } from '@prisjakt/ui/text';
import { useAppContext } from 'src/components/app-context';

type Props = {
  title?: string;
  value: string;
  onClick: () => void;
};

export const AppliedFilter = ({ title, value, onClick }: Props) => {
  const { t } = useAppContext();
  return (
    <AppliedFilterButton
      onClick={onClick}
      containerProps={{ 'data-test': 'AppliedFilter' }}
      style={{}}
    >
      <ButtonText behavior={Behavior.OnelineEllipsis}>
        {title
          ? t('filter', 'applied-filter.filter-with-name', {
              name: title,
              value,
            })
          : value}
      </ButtonText>
      <ButtonIcon>
        <IconClose />
      </ButtonIcon>
    </AppliedFilterButton>
  );
};

const AppliedFilterButton = styled(TagButton)`
  min-width: 0;
`;
